import { writable } from 'svelte/store';
import { detectMob } from '../v7/utils/Dom';

export const scrollBlockRequest = (function scrollBlockRequest() {
	const isMobile = detectMob();
	const { update } = writable<Symbol[]>([])
	function blockControl (request: number) {
		if (!isMobile) return;
		if (request > 0) {
			document.body.classList.add("scroll-block")
		} else {
			document.body.classList.remove("scroll-block")
		}
	}
	function blockRequest(symbol: Symbol) {
		update((prev) => {
			const a = [...prev.filter((v) => v !== symbol), symbol]
			blockControl(a.length)
			return a
		})
	}
	function removeRequest(symbol: Symbol) {
		update((prev) => {
			const a = prev.filter((v) => v !== symbol)
			blockControl(a.length)
			return a
		})
	}
	return { blockRequest, removeRequest }
})()


